<template>

  
  <div >

     <span class="hiperlink" @click="meter()">智慧水錶</span>   
    <br> 
    <br> 
    <span class="hiperlink"  @click="newInfo()">最新消息</span>    
    <br> 
    <br>
    <span class="hiperlink"  @click="news()">新聞稿</span>  
    <br> 
    <br> 
    <span class="hiperlink" @click="eBill()">電子帳單</span>    
    <br> 
    <br>
    <span class="hiperlink" @click="billService()">帳務服務</span>    
    <br> 
    <br> 
    <span class="hiperlink"  @click="waterCut()">停水資訊</span>    
    <br> 
    <br> 
    <span class="hiperlink" @click="announce()">文宣及出版品</span>
    <br> 
    <br>   
    <span class="hiperlink" @click="eBook()">案例電子書</span>    

  </div>
  

</template>

<script>

export default {
  // 相關連結
  name: 'Link',
  data() {
    return {
     
    };
  },
  async created() {


  },
  mounted() {
  },
  methods: {
    meter() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    newInfo() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    news() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    eBill() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    billService() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    waterCut() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    announce() {
      window.open('https://www.google.com.tw/', '_blank')
    },
    eBook() {
      window.open('https://www.google.com.tw/', '_blank')
    }
  }
}
</script>

<style scoped>
.hiperlink:hover{
    color: #d81616;
    cursor: pointer;
}


</style>


